import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, img } from "@/lib/api";
import { REQUEST_TYPES } from "@/components/RequestForm";

const STATUSES = ["nuova", "in lavorazione", "in attesa del cliente", "reso autorizzato", "rimborso da eseguire", "coupon proposto", "chiusa"];

export default function AdminRequests() {
  const [list, setList] = useState([]);
  const [type, setType] = useState("");
  useEffect(() => {
    api.get("/admin/requests").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  const patch = async (r, body) => {
    try {
      const { data } = await api.patch(`/admin/requests/${r.id}`, body);
      setList((xs) => xs.map((x) => (x.id === r.id ? data : x)));
      toast.success("Richiesta aggiornata");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const shown = list.filter((r) => !type || r.type === type);

  return (
    <div className="max-w-6xl" data-testid="admin-requests-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-display text-3xl font-semibold">Assistenza, resi e garanzie</h1>
        <select value={type} onChange={(e) => setType(e.target.value)} className="h-10 rounded-lg border border-white/10 bg-[#12141A] px-3 text-sm" data-testid="requests-filter">
          <option value="">Tutti i tipi</option>{REQUEST_TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </div>
      <div className="mt-6 space-y-3">
        {shown.map((r) => (
          <details key={r.id} className="rounded-2xl border border-white/10 bg-[#12141A] p-4 text-sm" data-testid={`request-row-${r.number}`}>
            <summary className="flex cursor-pointer flex-wrap items-center gap-3">
              <span className="font-mono text-xs text-slate-500">{r.number}</span><span className="rounded-full bg-[#0066FF]/15 px-2 py-0.5 text-xs">{r.type}</span>
              <span className="font-medium">{r.name}</span><span className="text-slate-400">{r.email}</span>
              <span className="ml-auto text-xs text-slate-400">{r.status} · {new Date(r.created_at).toLocaleString("it-IT")}</span>
            </summary>
            <div className="mt-4 grid gap-4 md:grid-cols-[1fr_280px]">
              <div>
                <p className="text-xs text-slate-400">Tel. {r.phone || "-"} · Ordine {r.order_number || "-"} · Prodotto {r.product || "-"}</p>
                <p className="mt-2 whitespace-pre-wrap">{r.message}</p>
                <div className="mt-3 flex flex-wrap gap-2">{(r.photos || []).map((u) => <a key={u} href={img(u)} target="_blank" rel="noreferrer"><img src={img(u)} alt="" className="h-20 w-20 rounded-lg object-cover" /></a>)}</div>
              </div>
              <div className="space-y-2">
                <select value={r.status} onChange={(e) => patch(r, { status: e.target.value })} className="h-10 w-full rounded-lg border border-white/10 bg-[#0A0B0E] px-2" data-testid={`request-status-${r.number}`}>
                  {STATUSES.map((s) => <option key={s}>{s}</option>)}
                </select>
                <textarea defaultValue={r.notes} onBlur={(e) => e.target.value !== r.notes && patch(r, { notes: e.target.value })} rows={4} placeholder="Note interne"
                  className="w-full rounded-lg border border-white/10 bg-white/5 p-2" data-testid={`request-notes-${r.number}`} />
              </div>
            </div>
          </details>
        ))}
        {!shown.length && <p className="text-sm text-slate-500">Nessuna richiesta.</p>}
      </div>
    </div>
  );
}
